/* eslint-disable no-undef */
import styled from 'styled-components'
import { Button } from '@dasa-health/alma-react'
import CustomTheme, { navTheme } from 'themes'

export const Section = styled.div`
  display: flex;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  ${CustomTheme.breakPoint.tablet} {
    height: auto;
  }
`

export const SubtitleContainer = styled.div`
  max-width: 379px;

  p {
    font-size: 1.12rem;
  }
`

export const Footer = styled.footer`
  margin-top: 64px;
  padding-bottom: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: min-content;
`
export const RouteButton = styled(Button)`
  &&& {
    background: ${navTheme.colors.brand.primary[30]};
    &:hover {
      background: ${navTheme.colors.brand.primary[10]} !important;
    }
  }
`
